export default "__VITE_ASSET__C$53q5L6__"